define('SearchSpring.Facets.Helper', [
    'SearchSpring.Facets.Translator'
], function SearchSpringFacetsHelper(
    Translator
) {
    'use strict';

    return {
        settings_stack: [],
        // @method parseUrl Returns a Facet.Translator for the passed url and configuration @static
        parseUrl: function parseUrl(fullurl, configuration, isCategoryPage) {
            return new Translator(fullurl, null, configuration, isCategoryPage);
        },

    // @method setCurrent @param {Object} settings @static
        setCurrent: function setCurrent(settings) {
            this.settings_stack.push(settings);
        },

    // @method getCurrent @returns {Object} @static
        getCurrent: function getCurrent() {
            return this.settings_stack[this.settings_stack.length - 1];
        },

    // @method getPrevious @returns {Object} @static
        getPrevious: function getPrevious() {
            return this.settings_stack[this.settings_stack.length - 2];
        }
    };
});

